import { DEAL_STATUSES, DEAL_METRICS, DealHeroCard, LabeledButtonWithCountMultiple, COMPANY_LEVELS, DEAL_PROJECT_TYPES } from "@loanbossinc/component-library";

export default [
  {
    label: "Project type",
    metricId: DEAL_METRICS.PROJECT_TYPE,
    activeDealStatus: [DEAL_STATUSES.PIPELINE, DEAL_STATUSES.DEAD],
    activeProjectType: [],
    isMFOnly: null
  },
  /*
   * {// new Metric
   *     label:'Pricing guidance',
   *     metricId: DEAL_METRICS.PROJECT_TYPE,
   *     activeDealStatus: [DEAL_STATUSES.PIPELINE, DEAL_STATUSES.DEAD],
   *     activeProjectType: [DEAL_PROJECT_TYPES.STABILIZED, DEAL_PROJECT_TYPES.VALUE_ADD],    //
   *     isMFOnly: null
   * },
   */
  {
    label: "Est. Development cost",
    metricId: DEAL_METRICS.DEVELOPMENT_COST,
    activeDealStatus: [DEAL_STATUSES.PIPELINE, DEAL_STATUSES.DEAD],
    activeProjectType: [DEAL_PROJECT_TYPES.CONSTRUCTION],
    isMFOnly: null
  },
  {
    label: "Closing date",
    metricId: DEAL_METRICS.CLOSING_DATE,
    activeDealStatus: [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE, DEAL_STATUSES.MODIFYING, DEAL_STATUSES.ADDING_SUPPLEMENTAL],
    activeProjectType: [],
    isMFOnly: null
  },
  {
    label: "Purchase price",
    metricId: DEAL_METRICS.PURCHASE_PRICE,
    activeDealStatus: [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE, DEAL_STATUSES.MODIFYING, DEAL_STATUSES.ADDING_SUPPLEMENTAL],
    activeProjectType: [DEAL_PROJECT_TYPES.STABILIZED, DEAL_PROJECT_TYPES.VALUE_ADD],
    isMFOnly: null
  },
  {
    label: "Development Cost",
    metricId: DEAL_METRICS.DEVELOPMENT_COST,
    activeDealStatus: [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE, DEAL_STATUSES.MODIFYING, DEAL_STATUSES.ADDING_SUPPLEMENTAL],
    activeProjectType: [DEAL_PROJECT_TYPES.CONSTRUCTION],
    isMFOnly: null
  },
  {
    label: "Square Feet",
    metricId: DEAL_METRICS.SQUARE_FEET,
    activeDealStatus: [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE, DEAL_STATUSES.MODIFYING, DEAL_STATUSES.ADDING_SUPPLEMENTAL],
    activeProjectType: [],
    isMFOnly: true
  },
  {
    label: "Units",
    metricId: DEAL_METRICS.MF_UNITS,
    activeDealStatus: [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE, DEAL_STATUSES.MODIFYING, DEAL_STATUSES.ADDING_SUPPLEMENTAL],
    activeProjectType: [],
    isMFOnly: false
  },
  {
    label: "Sales Price",
    metricId: DEAL_METRICS.SALES_PRICE,
    activeDealStatus: [DEAL_STATUSES.SOLD],
    activeProjectType: [],
    isMFOnly: null
  },
  {
    label: "Sales Date",
    metricId: DEAL_METRICS.EXIT_DATE,
    activeDealStatus: [DEAL_STATUSES.SOLD],
    activeProjectType: [],
    isMFOnly: null
  },
  {
    label: "Exit cap",
    metricId: DEAL_METRICS.EXIT_CAP,
    activeDealStatus: [DEAL_STATUSES.SOLD],
    activeProjectType: [],
    isMFOnly: null
  }
];
